interface ImageProps {
  url?: string;
  alt?: string;
  caption?: string;
  fullWidth?: boolean;
}

export function ImageBlock({ props }: { props: ImageProps }) {
  if (!props.url) return null;
  return (
    <figure className={props.fullWidth ? 'w-full' : 'max-w-2xl mx-auto'}>
      <img src={props.url} alt={props.alt ?? ''} className="w-full rounded-xl object-cover" />
      {props.caption && (
        <figcaption className="text-center text-xs text-zinc-400 mt-2">{props.caption}</figcaption>
      )}
    </figure>
  );
}
